/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import FromToPicker from '../BaseComponent/FromToPicker'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Loader from '../loaders/loader'
import {Map, TileLayer, Marker} from 'react-leaflet'

// const { compose, withProps, withState, withHandlers } = require("recompose");
// const {
//     withScriptjs,
//     withGoogleMap,
//     GoogleMap,
//     Marker,
// } = require("react-google-maps");
// const style = {
//     width: '100%',
//     height: '310px',
//     marginTop: '30px',
//     border: '1px solid #FFBE2E',
//     borderRadius : '10px',
//     position:'static'

// };

// const MapWithControlledZoom = compose(
//     withProps({
//         googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw&v=3.exp&libraries=geometry,drawing,places",
//         loadingElement: <div style={{ height: `100%` }} />,
//         containerElement: <div style={{ height: `300px` }} />,
//         mapElement: <div style={{ height: `100%` }} />,
//     }),
//     withState('zoom', 'onZoomChange', 8),
//     withHandlers(() => {
//         const refs = {
//             map: undefined,
//         }
//         return {
//             onMapMounted: () => ref => {
//                 refs.map = ref
//             },
//             onZoomChanged: ({ onZoomChange }) => () => {
//                 onZoomChange(refs.map.getZoom())
//             }
//         }
//     }),
//     withScriptjs,
//     withGoogleMap
// )(props =>
//     <GoogleMap
//         style={style}
//         defaultCenter={{ lat:  props.lat, lng: props.lng }}
//         zoom={12}
//         ref={props.onMapMounted}
//         onZoomChanged={props.onZoomChanged}
//     >
//         <Marker
//             position={{ lat: props.lat, lng: props.lng }}
//             icon={require('../../image/requestPack.png')}

//         >
//         </Marker>

//     </GoogleMap>
// );

class NotLocationNotEdited extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      printInfo: [],
      delivery: [],
      buttonClicked: false,
      fromDate: '',
      toDate: '',
      mapModal: false,
      Drivers: [],
      driverId: ''
    }
  }

  getReport = (
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    params = sessionStorage.getItem('params')
  ) => {
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            delivery: response.data.object.result,
            buttonClicked: true,
            countAll: response.data.object.countAll,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  onResultFetched(data) {
    this.setState({
      delivery: data
    })
  }

  changeDropDown(data) {
    this.setState({
      delivery: data,
      countAll: this.state.countAll
    })
  }

  filter() {
    var minDate = this.state.fromDate
    var maxDate = this.state.toDate
    sessionStorage.setItem('pageNumber', '1')

    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId

    if (minDate === '' && maxDate === '' && driverId === '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        groupingStatus: Number(this.state.grouping)
      })
      sessionStorage.setItem('pageNumber', '1')
      sessionStorage.setItem('dropDownVal', '10')
      sessionStorage.setItem(
        'params',
        `driverId=${driverId}&planDateMin=${minDate}&planDateMax=${maxDate}&sortBy=driverId_asc,dispatchDate_asc`
      )
      this.getReport()
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED}?export=true&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED}?export=true&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['dispatchDate'] = jMoment(excelReport[i]['dispatchDate']).format('jYY/jM/jD HH:mm')
            excelReport[i]['invoice']['registerDate'] = jMoment(excelReport[i]['invoice']['registerDate']).format(
              'jYY/jM/jD HH:mm'
            )
            if (excelReport[i]['deliveredBetween']) {
              excelReport[i]['deliveredBetween'] = 'در بازه'
            } else {
              excelReport[i]['deliveredBetween'] = 'خارج از بازه'
            }
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  openMap = (latitude, longitude, recipientName) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      mapModal: true
    })
  }
  closeMap = () => {
    this.setState({
      latitude: '',
      longitude: '',
      recipientName: '',
      mapModal: false
    })
  }

  render() {
    const modalStyle = {
      maxWidth: '96%',
      height: '300px'
    }

    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'راننده',
      'تاریخ تحویل',
      'تحویل ',
      'شناسه فاکتور',
      'شماره فاکتور',
      'تاریخ ثبت',
      'خریدار',
      'تحویل گیرنده',
      'موبایل'
    ]
    let {loading} = this.state
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={' گزارش فاکتور هایی که موقعیت نداشته و ویرایش نشده ' + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driver'}
                field={'driver.name'}
                title={'راننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'dispatchDate'}
                field={'dispatchDate'}
                title={'تاریخ تحویل'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveredBetween'}
                field={'deliveredBetween'}
                title={'تحویل'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'registerDate'}
                field={'invoice.registerDate'}
                title={'تاریخ ثبت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'خریدار'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recipientName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'تحویل گیرنده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header={' گزارش فاکتور هایی که موقعیت نداشته و ویرایش نشده '}
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={10}
              rightColSpan={4}
              centerColSpan={1}
              leftColSpan={5}
              centerSection={''}
              rightSection={
                'تاریخ از : ' +
                (this.state.toPrintDate === undefined ? '' : this.state.toPrintDate) +
                ' تا ' +
                (this.state.fromPrintDate === undefined ? '' : this.state.fromPrintDate)
              }
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{list.driver === null ? '-' : list.driver.name}</td>
                  <td>{jMoment(list.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{list.deliveredBetween ? 'در بازه' : 'خارج از بازه'}</td>
                  <td>{list.invoice.invoiceId}</td>
                  <td>{list.invoice.invoiceNum}</td>
                  <td>{jMoment(list.invoice.registerDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{list.invoice.buyerName}</td>
                  <td>{list.invoice.recipientName}</td>
                  <td>{list.invoice.mobile === null ? '-' : list.invoice.mobile.replace(/\+98/g, '0')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>تحویل فاکتور ها</li>
            <li>گزارش فاکتورهایی که موقعیت نداشته و ویرایش نشده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED + '?export=true'}
                  excelColumns={[]}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>راننده</td>

                    <td>تاریخ تحویل</td>
                    <td>تحویل </td>
                    <td>شناسه فاکتور</td>
                    <td>شماره فاکتور</td>
                    <td>تاریخ ثبت</td>
                    <td>نام خریدار</td>
                    <td>نام تحویل گیرنده</td>
                    <td>موبایل</td>
                    <td>موقعیت</td>
                  </tr>
                  {this.state.delivery.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>
                        <span title={list.driver !== null ? list.driver.mobile : ''}>
                          {list.driver === null ? '-' : list.driver.name}
                        </span>
                      </td>
                      <td>{jMoment(list.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{list.deliveredBetween ? 'در بازه' : 'خارج از بازه'}</td>
                      <td>
                        <Link
                          to={{
                            pathname: '/baskets',
                            search: `?invoiceId=${list.invoice.invoiceId}`
                          }}
                          target={'_blank'}
                        >
                          {list.invoice.invoiceId}
                        </Link>
                      </td>
                      <td>{list.invoice.invoiceNum}</td>
                      <td>{jMoment(list.invoice.registerDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{list.invoice.buyerName}</td>
                      <td>{list.invoice.recipientName}</td>
                      <td>{list.invoice.mobile === null ? '-' : list.invoice.mobile.replace(/\+98/g, '0')}</td>
                      <td>
                        <button onClick={() => this.openMap(list.latitude, list.longitude, list.invoice.recipientName)}>
                          <img src={require('../../image/loc.svg')} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.mapModal} toggle={this.closeMap} size="lg">
          <ModalHeader toggle={this.closeMap}>
            <p>موقعیت تحویل سفارش برای : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <Marker position={[this.state.latitude, this.state.longitude]} />
              </Map>

              {/* <MapWithControlledZoom
                                lat = {this.state.latitude}
                                lng = {this.state.longitude}
                                customerLat = {this.state.latitude}
                                customerLng = {this.state.longitude}
                            /> */}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.closeMap}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default NotLocationNotEdited
